import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import LeadsData from "@/components/analytics/transaction/TablePage";
import Analytics from "@/components/analytics/transaction/AnalyticsPage.jsx";

const TransactionsDashboard = () => {
  const [activeTab, setActiveTab] = useState("leads");

  return (
    <div className="container mx-auto p-4">
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="leads">Transaction Data</TabsTrigger>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
        </TabsList>
        <TabsContent value="leads">
          <LeadsData />
        </TabsContent>
        <TabsContent value="analytics">
          <Analytics />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TransactionsDashboard;